import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '../../Themes/themeContext';
import { Area, KpiBarMultiple } from './KpiBarMultiple';
import { useTranslation } from '../../Locales/i18n/localizationService';
 
interface IProps {
	Percentage: number;
	CategoryPercentage: number;
	IsZeroActivityProject: boolean;
}

export const ProjectListItemPercentageBar: FunctionComponent<IProps> = props => {
	const { t } = useTranslation();
	const theme = useTheme();
	
	const [areas, setAreas] = useState<Array<Area>>([]);
	
	const ParseCategoryPercentage = (percentage: number) : number => {
		if (percentage === -3) return 0;
		if (percentage === -2) return 0;
		return props.CategoryPercentage;
	}
	
	const GetLeftOverTitle = () : string => {
		if (props.Percentage === -2) return t("ProjectListItemPercentageBar.NotRequestedButAllocated");
		if (props.Percentage === -3) return t("ProjectListItemPercentageBar.NotAllocatedButRequested");
		return t("ProjectListItemPercentageBar.NotAllocated");
	}

	const GetAllocatedTitle = () : string => {
		if (props.IsZeroActivityProject) return t("ProjectListItemPercentageBar.NotRequestedAndNotAllocated");
		return t("ProjectListItemPercentageBar.Allocated");
	}

	const GetAllocatedColor = () : string => {
		if (props.IsZeroActivityProject) return theme.semanticColors.activityZeroBackground;
		if (props.Percentage > 100) return theme.semanticColors.kpiOver;
		return theme.semanticColors.kpiUsed;
	}
	
	useEffect(() => {
		const allocated: Area = { Title: GetAllocatedTitle(), Percentage: props.Percentage === -3 ? 0 : props.Percentage, Color: GetAllocatedColor(), ShowPercentage: !props.IsZeroActivityProject };
		const category: Area = { Title: t("ProjectListItemPercentageBar.Category"), Percentage: ParseCategoryPercentage(props.Percentage), Color: theme.semanticColors.kpiCategory, ShowPercentage: true };
		setAreas([allocated, category]);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.Percentage, props.CategoryPercentage, props.IsZeroActivityProject]);

	return areas.length &&
			<KpiBarMultiple
				Areas={areas}
				LeftOverTitle={GetLeftOverTitle()}
				LeftOverColor={props.Percentage === -2 ? theme.semanticColors.kpiInfinite : theme.semanticColors.kpiFree}
			/>
}
